import { useLocalizationContext } from '@amzn/react-arb-tools';

/**
 * The active BCP-47 locale to hand to Intl (dates, times, numbers).
 *
 * Reads the locale from the ARB localization context, which LocalizationProvider resolves once for
 * the session: the user's saved preference / browser language when the Localization flag is on, and
 * the default locale (en-US) when it's off. That context is the single source of truth for "what
 * locale is the UI in", so formatting stays consistent with the translated text. Outside an
 * MbmProvider (e.g. a bare unit test) the context returns its own default locale, so the result is
 * always a non-empty BCP-47 tag.
 *
 * Prefer this over reading `i18n.language`: it follows the resolved app locale rather than whatever
 * language i18next happened to detect, and it lets a component drop its `useTranslation` dependency
 * once its text has moved to useLocalizedText.
 */
export function useLocale(): string {
  return useLocalizationContext().localizationContext.getLocale();
}
